const HomeInnerLayout = ({ children }) => {
    return <>{children}</>;
};

export default HomeInnerLayout;
